import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './_interceptors/auth.interceptor';
import { AuthGuard } from './services/auth.guard';
import { RoleGuard } from './services/role.guard';

import { ApiClientService } from './services/api-client.service';
// Import the library
import { IsotopeModule } from 'ngx-isotope';
// import { MatSliderModule } from '@angular/material/slider';
import {DemoMaterialModule} from './material-module';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module



import { AppComponent } from './app.component';
import { SearchFilterPipe } from './searchfilter.pipe';
import { ModalComponent } from './modal/modal.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { AccountProfilePageComponent } from './pages/account-profile-page/account-profile-page.component';
import { AccountContactShippingAddressPageComponent } from './account-contact-shipping-address-page/account-contact-shipping-address-page.component';
import { GridBannerComponent } from './grid-banner/grid-banner.component';
import { PageContentComponent } from './page-content/page-content.component';
import { PagesComponent } from './pages/pages.component';
import { HomeComponent } from './pages/home/home.component';
import { ShopProductsComponent } from './pages/shop-products/shop-products.component';
import { ShopCategoryPageComponent } from './pages/shop-category-page/shop-category-page.component';
import { ShopDiscountsPageComponent } from './pages/shop-discounts-page/shop-discounts-page.component';
import { ShopCartPageComponent } from './pages/shop-cart-page/shop-cart-page.component';
import { ShopCheckoutPageComponent } from './pages/shop-checkout-page/shop-checkout-page.component';
import { AccountOrdersPageComponent } from './pages/account-orders-page/account-orders-page.component';
import { AccountWishlistPageComponent } from './pages/account-wishlist-page/account-wishlist-page.component';
import { AccountShippingAddressPageComponent } from './pages/account-shipping-address-page/account-shipping-address-page.component';
import { AccountTicketsPageComponent } from './pages/account-tickets-page/account-tickets-page.component';
import { AccountOrderTrackingPageComponent } from './pages/account-order-tracking-page/account-order-tracking-page.component';
import { AccountLoginPageComponent } from './pages/account-login-page/account-login-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { ServicesPageComponent } from './pages/services-page/services-page.component';
import { ContactsPageComponent } from './pages/contacts-page/contacts-page.component';
import { TermsConditionsPageComponent } from './pages/terms-conditions-page/terms-conditions-page.component';
import { CareersPageComponent } from './pages/careers-page/careers-page.component';
import { FaqPageComponent } from './pages/faq-page/faq-page.component';
import { ShopSingleProductPageComponent } from './pages/shop-single-product-page/shop-single-product-page.component';
import { AccountSingleTicketPageComponent } from './pages/account-single-ticket-page/account-single-ticket-page.component';
import { AccountOrderDetailsPageComponent } from './pages/account-order-details-page/account-order-details-page.component';
import { PasswordRecoveryComponent } from './pages/password-recovery/password-recovery.component';
import { AccountOrderViewComponent } from './pages/account-order-view/account-order-view.component';
import { AccountSingleTicketComponent } from './pages/account-single-ticket/account-single-ticket.component';
import { CheckoutShippingPageComponent } from './pages/checkout-shipping-page/checkout-shipping-page.component';
import { CheckoutPaymentPageComponent } from './pages/checkout-payment-page/checkout-payment-page.component';
import { CheckoutReviewPageComponent } from './pages/checkout-review-page/checkout-review-page.component';
import { ShopSingleProductViewComponent } from './pages/shop-single-product-view/shop-single-product-view.component';
import { CheckoutStepsComponent } from './checkout-steps/checkout-steps.component';
import { CheckoutAddressPageComponent } from './pages/checkout-address-page/checkout-address-page.component';
import { CheckoutCompletePageComponent } from './pages/checkout-complete-page/checkout-complete-page.component';
import { CheckoutFailedPageComponent } from './pages/checkout-failed-page/checkout-failed-page.component';
import { OrdersComponent } from './sellers/account/orders/orders.component';
import { ShopsComponent } from './sellers/account/shops/shops.component';
import { SellerInfoComponent } from './sellers/account/seller-info/seller-info.component';
import { PaymentInfoComponent } from './sellers/account/payment-info/payment-info.component';
import { TicketsComponent } from './sellers/account/tickets/tickets.component';
import { CreateShopComponent } from './sellers/account/create-shop/create-shop.component';
import { ViewShopComponent } from './sellers/account/view-shop/view-shop.component';
import { CreateNewProductComponent } from './sellers/account/create-new-product/create-new-product.component';
import { ProductGalleryComponent } from './sellers/account/product-gallery/product-gallery.component';
import { ListedproductsComponent } from './sellers/account/listedproducts/listedproducts.component';
import { ShopaddressComponent } from './sellers/account/shopaddress/shopaddress.component';
import { ModalsComponent } from './modals/modals.component';
import { SubmitTicketComponent } from './account/pages/submit-ticket/submit-ticket.component';
import { SearchResultsComponent } from './pages/search-results/search-results.component';
import { SellerDetailsComponent } from './sellers/registration/seller-details/seller-details.component';
import { DepositDetailsComponent } from './sellers/registration/deposit-details/deposit-details.component';
import { BusinessDetailsComponent } from './sellers/registration/business-details/business-details.component';
import { ReviewCompleteComponent } from './sellers/registration/review-complete/review-complete.component';
import { SelleronboardStepsComponent } from './selleronboard-steps/selleronboard-steps.component';
import { LoaderComponent } from './partials/loader/loader.component';
import { CurrentUserComponent } from './partials/current-user/current-user.component';
import { MenuCurrentUserComponent } from './partials/menu-current-user/menu-current-user.component';
import { FilterComponent } from './services/filter/filter.component';
import { ViewEditProductComponent } from './sellers/account/view-edit-product/view-edit-product.component';
import { ProductInformationBasicComponent } from './sellers/account/product-details/product-information-basic/product-information-basic.component';
import { ProductPricingDetailsComponent } from './sellers/account/product-details/product-pricing-details/product-pricing-details.component';
import { ProductImageGalleryComponent } from './sellers/account/product-details/product-image-gallery/product-image-gallery.component';
import { ProductSettingsDetailsComponent } from './sellers/account/product-details/product-settings-details/product-settings-details.component';
import { ProductDeliveryDetailsComponent } from './sellers/account/product-details/product-delivery-details/product-delivery-details.component';
import { ProductEditBannerTitleComponent } from './partials/product-edit-banner-title/product-edit-banner-title.component';
import { StoreWarehousesComponent } from './sellers/account/store-warehouses/store-warehouses.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SellerDashboardComponent } from './sellers/account/seller-dashboard/seller-dashboard.component';
import { CurrentBusinessAccountBannerComponent } from './partials/current-business-account-banner/current-business-account-banner.component';
import { SellersDashboardNavsComponent } from './partials/sellers-dashboard-navs/sellers-dashboard-navs.component';
import { SellerActiveOrdersComponent } from './sellers/account/dashboard-pages/seller-active-orders/seller-active-orders.component';
import { SellerDeliveriesComponent } from './sellers/account/dashboard-pages/seller-deliveries/seller-deliveries.component';
import { SellerOrdersDynamicComponent } from './sellers/account/dashboard-pages/seller-orders-dynamic/seller-orders-dynamic.component';
import { FlaggedProductsTableComponent } from './sellers/account/dashboard-pages/flagged-products-table/flagged-products-table.component';
import { SellerAccountTransactionsComponent } from './sellers/account/dashboard-pages/seller-account-transactions/seller-account-transactions.component';
import { ShopProductsGridviewComponent } from './partials/shop-products-gridview/shop-products-gridview.component';
import { ShopSidebarCategoryMenuAndFiltersComponent } from './partials/shop-sidebar-category-menu-and-filters/shop-sidebar-category-menu-and-filters.component';
import { MenuShopCartItensComponent } from './partials/menu-shop-cart-itens/menu-shop-cart-itens.component';
import { ProductsYouMayLikeComponent } from './partials/products-you-may-like/products-you-may-like.component';
import { OrderSummarySidebarComponent } from './partials/sidebar/order-summary-sidebar/order-summary-sidebar.component';
import { RecentViewedProductsComponent } from './partials/sidebar/recent-viewed-products/recent-viewed-products.component';
import { ProductAddsBannerSidebarComponent } from './partials/sidebar/product-adds-banner-sidebar/product-adds-banner-sidebar.component';
import { ViewSaleDetailsComponent } from './sellers/account/view-sale-details/view-sale-details.component';
import { OrderDetailsModalComponent } from './partials/modals/order-details-modal/order-details-modal.component';
import { BackorderDetailsModalComponent } from './partials/modals/backorder-details-modal/backorder-details-modal.component';
import { SaleDetailsModalComponent } from './partials/modals/sale-details-modal/sale-details-modal.component';
import { MarkSaleAsreadyForcollectionComponent } from './partials/modals/mark-sale-asready-forcollection/mark-sale-asready-forcollection.component';
import { CatalogueDepartmentsComponent } from './system-pages/modules-pages/e-commerce/catalogue-departments/catalogue-departments.component';
import { FeaturedProductsCorouselComponent } from './partials/featured-products-corousel/featured-products-corousel.component';
import { LikedProductsCorouselComponent } from './partials/liked-products-corousel/liked-products-corousel.component';
import { SellerAuthPageComponent } from './pages/seller-auth-page/seller-auth-page.component';
import { CourierMobilePaymentComponent } from './external-app/courier-mobile-payment/courier-mobile-payment.component';
import { ShopCategoryProductsComponent } from './pages/shop-category-products/shop-category-products.component';
import { CatergoryProductsCourouselComponent } from './partials/catergory-products-courousel/catergory-products-courousel.component';
import { AccountEmailVerificationComponent } from './pages/account-email-verification/account-email-verification.component';

const appRoutes: Routes = [
  //site pages
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'home/products', component: ShopProductsComponent },
  { path: 'home/categories', component: ShopCategoryPageComponent },
  { path: 'home/discounted', component: ShopDiscountsPageComponent },
  { path: 'services', component: ServicesPageComponent },
  { path: 'faq', component: FaqPageComponent },
  { path: 'about', component: AboutPageComponent },
  { path: 'contacts', component: ContactsPageComponent },

  //site pages
  { path: 'shiping-rates', component: ContactsPageComponent },
  { path: 'refunds', component: ContactsPageComponent },
  { path: 'advertise', component: ContactsPageComponent },
  { path: 'sell-with-us', component: ContactsPageComponent },
  { path: 'affiliate', component: ContactsPageComponent },
  { path: 'contacts', component: ContactsPageComponent },
  { path: 'terms-conditions', component: TermsConditionsPageComponent },
  { path: 'careers', component: CareersPageComponent },
  { path: 'search/:term', component: SearchResultsComponent },

  //account pages
  { path: 'account', component: AccountOrdersPageComponent, canActivate: [AuthGuard] },
  { path: 'account/login', component: AccountLoginPageComponent },
  { path: 'account/become-a-seller', component: SellerAuthPageComponent },
  { path: 'account/password-recovery', component: PasswordRecoveryComponent },
  { path: 'account/email-verify', component: AccountEmailVerificationComponent },
  { path: 'account/orders', component: AccountOrdersPageComponent , canActivate: [AuthGuard] },
  { path: 'account/orders/:id', component: AccountOrderViewComponent, canActivate: [AuthGuard] },
  { path: 'account/wishlist', component: AccountWishlistPageComponent , canActivate: [AuthGuard]},
  { path: 'account/profile', component: AccountProfilePageComponent, canActivate: [AuthGuard]},
  { path: 'account/address', component: AccountShippingAddressPageComponent, canActivate: [AuthGuard] },
  { path: 'account/tickets', component: AccountTicketsPageComponent, canActivate: [AuthGuard] },
  { path: 'account/tickets/:id', component: AccountSingleTicketPageComponent, canActivate: [AuthGuard] },
  { path: 'account/order-tracking/:id', component: AccountOrderTrackingPageComponent, canActivate: [AuthGuard] },
  { path: 'account/submit-ticket', component: SubmitTicketComponent, canActivate: [AuthGuard] },

  //shop pages
  { path: 'shop/categories', component: ShopCategoryPageComponent },
  { path: 'shop/products', component: ShopProductsComponent },
  { path: 'shop/products/:id', component: ShopSingleProductViewComponent },
  { path: 'shop/category/products/:id', component: ShopCategoryProductsComponent },
  { path: 'shop/discounted', component: ShopDiscountsPageComponent },

  //shop transaction pages
  { path: 'shop/cart', component: ShopCartPageComponent },
  { path: 'shop/checkout', redirectTo: 'shop/checkout/address', pathMatch: 'full' },
  { path: 'shop/checkout/address', component: ShopCheckoutPageComponent, canActivate: [AuthGuard] },
  { path: 'shop/checkout/shipping', component: CheckoutShippingPageComponent, canActivate: [AuthGuard] },
  { path: 'shop/checkout/payment', component: CheckoutPaymentPageComponent, canActivate: [AuthGuard] },
  { path: 'shop/checkout/review', component: CheckoutReviewPageComponent, canActivate: [AuthGuard] },
  { path: 'shop/checkout/complete', component: CheckoutCompletePageComponent, canActivate: [AuthGuard] },
  { path: 'shop/checkout/failure', component: CheckoutFailedPageComponent, canActivate: [AuthGuard] },

  //sellers account
  { path: 'sellers/register/user-details', component: SellerDetailsComponent, canActivate: [AuthGuard]},
  { path: 'sellers/register/bank-details', component: DepositDetailsComponent, canActivate: [AuthGuard] },
  { path: 'sellers/register/business-details', component: BusinessDetailsComponent, canActivate: [AuthGuard] },
  { path: 'sellers/register/complete', component: ReviewCompleteComponent, canActivate: [AuthGuard] },

  //sellers dashboard
  { path: 'sellers/dashboard/active-orders', component: SellerActiveOrdersComponent, canActivate: [AuthGuard]},
  { path: 'sellers/dashboard/deliveries', component: SellerDeliveriesComponent, canActivate: [AuthGuard]},
  { path: 'sellers/account/dynamic-orders/:type', component: SellerOrdersDynamicComponent, canActivate: [AuthGuard]},
  { path: 'sellers/dashboard/flagged-products', component: FlaggedProductsTableComponent, canActivate: [AuthGuard]},
  { path: 'sellers/dashboard/account-transactions', component: SellerAccountTransactionsComponent, canActivate: [AuthGuard]},

  { path: 'sellers/dashboard', component: SellerDashboardComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/create', component: CreateShopComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/orders', component: OrdersComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/profile', component: SellerInfoComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/tickets', component: TicketsComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/shop/:id', component: ViewShopComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/shops', component: ShopsComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/banking-details', component: PaymentInfoComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/create-product', component: ViewEditProductComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/product-gallery', component: ProductGalleryComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/shop-details', component: ListedproductsComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/address', component: ShopaddressComponent, canActivate: [AuthGuard, RoleGuard] },
  { path: 'sellers/account/products', component: ListedproductsComponent, canActivate: [AuthGuard, RoleGuard] },

  { path: 'courier/payment/online-mobile', component: CourierMobilePaymentComponent },

  


  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    AppComponent,
    SearchFilterPipe,
    ModalComponent,
    MenuComponent,
    FooterComponent,
    AccountProfilePageComponent,
    AccountContactShippingAddressPageComponent,
    AccountSingleTicketComponent,
    GridBannerComponent,
    PageContentComponent,
    PagesComponent,
    HomeComponent,
    ShopProductsComponent,
    ShopCategoryPageComponent,
    ShopDiscountsPageComponent,
    ShopCartPageComponent,
    ShopCheckoutPageComponent,
    AccountOrdersPageComponent,
    AccountWishlistPageComponent,
    AccountShippingAddressPageComponent,
    AccountTicketsPageComponent,
    AccountOrderTrackingPageComponent,
    AccountLoginPageComponent,
    AboutPageComponent,
    ServicesPageComponent,
    ContactsPageComponent,
    TermsConditionsPageComponent,
    CareersPageComponent,
    FaqPageComponent,
    ShopSingleProductPageComponent,
    AccountSingleTicketPageComponent,
    AccountOrderDetailsPageComponent,
    PasswordRecoveryComponent,
    AccountOrderViewComponent,
    CheckoutShippingPageComponent,
    CheckoutPaymentPageComponent,
    CheckoutReviewPageComponent,
    ShopSingleProductViewComponent,
    CheckoutStepsComponent,
    CheckoutAddressPageComponent,
    CheckoutCompletePageComponent,
    CheckoutFailedPageComponent,
    OrdersComponent,
    ShopsComponent,
    SellerInfoComponent,
    PaymentInfoComponent,
    TicketsComponent,
    CreateShopComponent,
    ViewShopComponent,
    CreateNewProductComponent,
    ProductGalleryComponent,
    ListedproductsComponent,
    ShopaddressComponent,
    ModalsComponent,
    SubmitTicketComponent,
    SearchResultsComponent,
    SellerDetailsComponent,
    DepositDetailsComponent,
    BusinessDetailsComponent,
    ReviewCompleteComponent,
    SelleronboardStepsComponent,
    LoaderComponent,
    CurrentUserComponent,
    MenuCurrentUserComponent,
    FilterComponent,
    ViewEditProductComponent,
    ProductInformationBasicComponent,
    ProductPricingDetailsComponent,
    ProductImageGalleryComponent,
    ProductSettingsDetailsComponent,
    ProductDeliveryDetailsComponent,
    ProductEditBannerTitleComponent,
    StoreWarehousesComponent,
    SellerDashboardComponent,
    CurrentBusinessAccountBannerComponent,
    SellersDashboardNavsComponent,
    SellerActiveOrdersComponent,
    SellerDeliveriesComponent,
    SellerOrdersDynamicComponent,
    FlaggedProductsTableComponent,
    SellerAccountTransactionsComponent,
    ShopProductsGridviewComponent,
    ShopSidebarCategoryMenuAndFiltersComponent,
    MenuShopCartItensComponent,
    ProductsYouMayLikeComponent,
    OrderSummarySidebarComponent,
    RecentViewedProductsComponent,
    ProductAddsBannerSidebarComponent,
    ViewSaleDetailsComponent,
    OrderDetailsModalComponent,
    BackorderDetailsModalComponent,
    SaleDetailsModalComponent,
    MarkSaleAsreadyForcollectionComponent,
    CatalogueDepartmentsComponent,
    FeaturedProductsCorouselComponent,
    LikedProductsCorouselComponent,
    SellerAuthPageComponent,
    CourierMobilePaymentComponent,
    ShopCategoryProductsComponent,
    CatergoryProductsCourouselComponent,
    AccountEmailVerificationComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    IsotopeModule,
    DemoMaterialModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes, {useHash: true, scrollPositionRestoration: 'enabled'}),
    BrowserAnimationsModule
  ],
  providers: [
    AuthGuard,
    RoleGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ApiClientService,

  ],
  exports: [RouterModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
